export default __webpack_public_path__ + "static/media/detail_banner2.7d15cef9.jpg";